import React from "react";
import { USAGE_STATS } from "../../../config/marketing/usage";
import Section from "../../../components/layout/marketing/Section";
import StatCard from "../components/StatCard";
import Chip from "../../../components/common/chip";
export default function UsageSection() {
    const topStats = USAGE_STATS.filter((s) => !s.highlight);
    const highlightStat = USAGE_STATS.find((s) => s.highlight);

    return (
        <Section id="usage" className="pb-40">
            <div className="grid grid-cols-1 lg:grid-cols-10 gap-16 items-center">
                {/* Left: Text */}
                <div className="lg:col-span-6 flex items-center md:items-start flex-col gap-5">
                    <Chip>Usage</Chip>

                    <h3 className="text-4xl md:text-5xl font-semibold leading-none md:leading-tight text-text-primary tracking-tight text-center md:text-left">
                        The <span className="bg-brand-gradient bg-clip-text text-transparent">Everyday Tasks</span> you
                        shouldn’t be doing.{" "}
                        <span className="bg-brand-gradient bg-clip-text text-transparent">Now Automated</span>
                    </h3>

                    <p className="text-text-secondary text-lg md:text-xl lg:text-2xl md:leading-relaxed leading-1 md:max-w-[90%] tracking-tight text-center md:text-left">
                        Your day is packed. Eikos Health clears the clutter: confirmations, reschedules, reminders, and
                        feedback, all automated on WhatsApp.
                    </p>

                    <p className="text-text-secondary text-base md:text-lg lg:text-xl leading-2 md:leading-relaxed tracking-tight text-center md:text-left">
                        The result? More time, fewer gaps, and a steady flow of new patients.
                    </p>
                </div>

                {/* Right: Stats */}
                <div className="lg:col-span-4">
                    {/* OUTER RELATIVE CONTAINER */}
                    <div className="relative mx-auto max-w-[520px]">
                        {/* SINGLE GLOW — behind everything */}
                        <div className="pointer-events-none absolute inset-0 -z-10 rounded-full bg-brand-start/20 blur-3xl" />

                        {/* Cards stack */}
                        <div className="flex flex-col gap-6">
                            {/* Top row */}
                            <div className="grid grid-cols-2 gap-6">
                                {topStats.map((stat) => (
                                    <StatCard key={stat.id} icon={stat.icon} value={stat.value} label={stat.label} />
                                ))}
                            </div>

                            {/* Highlight stat */}
                            {highlightStat && (
                                <div className="flex justify-center">
                                    <StatCard
                                        icon={highlightStat.icon}
                                        value={highlightStat.value}
                                        label={highlightStat.label}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Section>
    );
}
